/**
 * <SelectDaysInMonthField />
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './SelectDaysInMonthField.scss';
import SearchList from 'components/UI/SearchList';
import times from 'lodash/times';
import parseJson from '../../parseJson';

const DAYS_IN_MONTH = times(31, (idx)=>{
  return {
    label: (idx + 1).toString(),
    value: (idx + 1),
  }
});

const SelectItem = ({item, getItemLabel, selected, onClickSelect, selectText, selectedText}) => {
  return ( 
    <div className={classnames('select-day', { 'selected': selected,  })} onClick={onClickSelect}>
      {item.label}
    </div>
   );
}

export function selectDaysInMonth(props) {
  let value = parseJson(props.value);
  return ( 
    <SelectDaysInMonthField 
       {...props} 
       value={value} 
       onChange={(data)=>{ props.onChange(JSON.stringify(data)); }} />
  );
}

class SelectDaysInMonthField extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.state = {
      selected: this.props.value || [],
    }
  }

  componentWillReceiveProps({ value }) {
    if (Array.isArray(value)) {
      this.setState({
        selected: DAYS_IN_MONTH.filter((item)=>{ return value.indexOf(item.value) > -1;  }),
      });
    }
  }

  onSelect(selected) {
    let arr = selected.map((item)=>{
      return item.value;
    });

    this.props.onChange(arr);
  }


  render() {
    let {
      value,
    } = this.props;

    let {
      selected,
    } = this.state;

    return (
      <div className='select-days-in-month form-input'>
        <SearchList
          itemList={DAYS_IN_MONTH}
          components={{
            SelectItem,
            }}
          sortSelected={false}
          allowDeselect={true}
          mutipleSelect={true}
          hideSearchbar={true}
          onSelect={this.onSelect}
          selected={selected}
        />
      </div>
    )
  }
}

export default SelectDaysInMonthField;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SelectDaysInMonth/index.js